module.exports = __webpack_public_path__ + "static/media/como-14.88399ea9.jpg";